export default __webpack_public_path__ + "static/media/document.674b64ec.png";